import { useState ,createContext, useLayoutEffect, useEffect } from "react";
import KeyWordCard from "../components/subscription/forms/settingsForm_page/KeyWordCard";
import { getCollectionDocs, getWebsite, handleCheckExistance, handleSignUp } from "../firebase/firebase_functions";
import themeData from "../dataSets/theme";
import subjects from "../dataSets/subjects";

export const SubscriptionContext = createContext(null);

// =============================
// Subscription context provider
// =============================
export default function SubscriptionContextProvider({children}) {

    // Owner form
    const [ownerData,setOwnerData] = useState(()=>{
        const o = sessionStorage.getItem("webingo_ownerData");
        return o ? JSON.parse(o) : {};
    });
    const [ownerCredentials,setOwnerCredntials] = useState(()=>{
        const oc = sessionStorage.getItem("webingo_ownerCredentials");
        return oc ? JSON.parse(oc) : {email:"", password:""};
    });

    // Settings form
    const [websiteSettings,setWebsiteSettings] = useState(()=>{
        const s = sessionStorage.getItem("webingo_websiteSettings");
        return s ? JSON.parse(s) : {};
    });

    // Payment form - website creation
    const [website] = useState(()=>{
        const w = sessionStorage.getItem("webingo_website");
        return w ? JSON.parse(w) : {};
    });

    // Main progress bar
    const [progressState, setProgressState] = useState(()=>{
        const p = sessionStorage.getItem("webingo_progress");
        return p ? p : 1;
    });

    // Error messages handle
    const [problem, setProblem] = useState("");

    // Owner form inputs
    const [ownerName, setOwnerName] = useState("");
    const [ownerEmail, setOwnerEmail] = useState("");
    const [password, setPassword] = useState("");
    const [rePassword, setRePassword] = useState("");
    const [ownerPhone, setOwnerPhone] = useState("");

    // Settings form inputs
    const [domainName, setDomainName] = useState('');
    const [siteName, setSiteName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [details, setDetails] = useState('');
    const [subject, setSubject] = useState("");
    const [theme, setTheme] = useState("");
    const [keyWord, setKeyWord] = useState("");
    const [keyWordsArr, setKeyWordsArr] = useState([]);

    // Settings form => handle dropdown options
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [themeOptions, setThemeOptions] = useState([]);

    // Settings form => domain check handle
    const [isDomainChecking, setIsDomainChecking] = useState(false);
    const [domainSuggestions, setDomainSuggestions] = useState([]);
    const [domainCheckError, setDomainCheckError] = useState('');

    // Payment form inputs
    const [paymentMessage, setPaymentMessage] = useState("");
    const [cardName, setCardName] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [expiryDate, setExpiryDate] = useState("");
    const [cvv, setCvv] = useState("");
    const [paymentFlag, setPaymentFlag] = useState(false);

    // Initiate drop down options
    useLayoutEffect(()=>{
        try{
            setThemeOptions(themeData);
            setCategoryOptions(subjects);
        } catch(err){
            console.error("error on SubscriptionContext.jsx at useLayoutEffect without dependencies: ", err);
        }
    },[])
    // Hold website creation process data on session storage through the forms
    useLayoutEffect(()=>{
        try{
            sessionStorage.setItem("webingo_ownerCredentials", JSON.stringify(ownerCredentials));
            sessionStorage.setItem("webingo_ownerData", JSON.stringify(ownerData));
            sessionStorage.setItem("webingo_website", JSON.stringify(website));
            sessionStorage.setItem("webingo_websiteSettings", JSON.stringify(websiteSettings));
            sessionStorage.setItem("webingo_progress", JSON.stringify(progressState))
        }
        catch(error){
            console.error("Error fetching data from local storage:\n",error);
            return alert("Something went wrong, try reload the page");
        }
    },[ownerCredentials, ownerData, websiteSettings, website, progressState])
    // Handle error appear/dissappear on change
    useEffect(()=>{
        if(problem === ""){
            return;
        }
        else if(problem==="הפרטים שהוזנו כבר רשומים במערכת"|| problem==="המייל שהוזן כבר רשום במערכת" || problem==="מספר הפלאפון שהוזן כבר רשום במערכת"){
            setTimeout(()=>{
                setProblem("");
            },8000)
        }
        else if(problem==="סיסמא לא תקינה"){
            setTimeout(()=>{
                setProblem("");
            },15000)
        }
        else{
            setTimeout(()=>{
                setProblem("");
            },5000)
        }
    },[problem])
    // Handle payment message appear/dissappear on change
    useEffect(()=>{
        if(paymentMessage === ""){
            return;
        }
        else{
            setTimeout(()=>{
                setPaymentMessage("");
            },3000)
        }
    },[paymentMessage])

    // ===================
    // Owner creation form
    // ===================
    // Inputs validation
    const validateUser=(ownerName, ownerPhone, email, pass, rePass)=>{
        if(!email || !pass || !ownerName || !ownerPhone || !rePass || email==="" || pass === "" || ownerName === "" || ownerPhone ==="" || rePass === ""){
            setProblem("נא למלא את כל השדות!");
            return false;
        }
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const regexPhone = /^0\d{8,9}$/;
        const regexName = /^(?:[A-Za-z]{1,17} [A-Za-z]{1,17}|[א-ת]{1,17} [א-ת]{1,17})$/;
        // const regexPass = /^(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,36}$/;
        const regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*]{6,36}$/;
        if(!ownerName.match(regexName)){
            setProblem("שם לא תקין - אותיות בעברית/אנגלית בלבד (בין 2-35 תווים ורווח אחד)");
            return false;  
        }
        if(!email.match(regexEmail)){
            setProblem("אימייל לא תקין - אנא בדוק את האימייל שהזנת");
            return false;
        }
        if(!ownerPhone.match(regexPhone)){
            setProblem("מספר פלאפון לא תקין");
            return false;
        }
        if(!pass.match(regexPass)){
            setProblem("סיסמא לא תקינה - על הסיסמא להכיל 6-36 תווים באנגלית/מספרים, ואות אחת גדולה באנגלית");
            return false;
        }
        if(pass !== rePass){
            setProblem("הסיסמא לא תואמת");
            return false;
        }
        return true;
    }
    // Save the inputs data at session after check as owner data
    const handleCreateUser=async(nav, getTodayDate)=>{
        // Check inputs
        const isValid = validateUser(ownerName, ownerPhone, ownerEmail, password, rePassword);
        // Check if the user already exists
        const isExists = await handleCheckExistance(ownerEmail, ownerPhone);
        if(!isValid){
            // Just return to prevent continue, the message displayed as a problem to client
            return;
        }
        if(isExists?.email || isExists?.phone){
            // If the phone or the email already exists on system - show relevant message and will suggest to login
            if(isExists?.email&&isExists?.phone){
                setProblem("הפרטים שהוזנו כבר רשומים במערכת");
            }
            else if(isExists?.email&&!isExists?.phone){
                setProblem("המייל שהוזן כבר רשום במערכת");
            }
            else if(!isExists?.email&&isExists?.phone){
                setProblem("מספר הפלאפון שהוזן כבר רשום במערכת");
            }
            return;
        }

        // If validation pass and isnt exists on system - continue to phase 2
        if(isValid&&isExists?.email===false&&isExists?.phone===false){
            try{
                const newUser ={
                    _id: Date.now(),
                    name: ownerName.toLowerCase().trim(),
                    email: ownerEmail.toLowerCase().trim(),
                    phone: ownerPhone.trim(),
                    aiUsage: {
                        daily: {
                            date: getTodayDate(),
                            messagesUsed: 0,
                            tokensUsed: 0
                        },
                        limits: {
                            maxDailyMessages: 25,
                            maxDailyTokens: 10000
                        },
                        totalUsage: {
                            messagesUsed: 0,
                            tokensUsed: 0
                        }
                    },
                    createdAt: new Date(),
                }
                // Temporary save credentials on local to make an authentication sign in after payment
                setOwnerCredntials({email:ownerEmail.toLowerCase().trim(), password});
                setOwnerData(newUser);
                setProgressState(2);
                window.scrollTo({
                    top: 0,
                    behavior:"smooth"
                })
                nav("/webingo/website-creation-form");
            } catch(err){
                console.error("Error on handleCreateUser method at SubscriptionContext.jsx: ",err);
            }
        }
    }

    // ======================
    // Settings creation form
    // ======================
    // Inputs validation
    const validateSettings = (domainName, siteName, email, phone, details, subject, theme, keyWordsArr)=>{
        if( !domainName || !siteName || !email || !phone || !details || !subject || !theme || !keyWordsArr || domainName === "" || siteName === "" || email==="" || phone ==="" || details === "" || subject === "" || Object.keys(theme).length === 0 || keyWordsArr.length === 0){
            setProblem("נא למלא את כל השדות!");
            return false;
        }
        const regexDomainName = /^(?:[A-Za-z]{1,17}.[A-Za-z]{1,17})$/;
        const regexSiteName = /^(?:[A-Za-zא-ת]+ ?){1,35}$/;
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const regexPhone = /^0\d{8,9}$/;
        const regexDetails = /^[A-Za-z\u0590-\u05FF0-9 !@#$%^&*()_\-=+*/.><,?'"\]\[}{\\|`~:;]{10,150}$/;
        if(!domainName.match(regexDomainName)){
            setProblem("הדומיין חייב להכיל אותיות באנגלית בלבד ו - .");
            return false;
        }
        if(!siteName.match(regexSiteName)){
            setProblem("שם האתר חייב להכיל אותיות בלבד באנגלית/עברית ויכול להכיל רווחים");
            return false;
        }
        if(!email.match(regexEmail)){
            setProblem("אימייל לא תקין - נא בדוק את האימייל שהזנת");
            return false;
        }
        if(!phone.match(regexPhone)){
            setProblem("מספר פלאפון לא תקין");
            return false;
        }
        if(!details.match(regexDetails)){
            setProblem("תיאור כללי חייב להיות בין 10-150 תווים");
            return false;
        }
        return true;
    }
    // Save the inputs data at session after check as settings data
    const handleCreateSettings=async(nav)=>{
        // Validation check
        const isValid = validateSettings(domainName, siteName, email, phone, details, subject, theme, keyWordsArr);
        if(isValid){
            try{
                // Main struct of website's settings
                const newSettings={
                    domain: domainName.trim().toLowerCase(),
                    website_name: siteName.trim(),
                    email: email.trim(),
                    phone: phone.trim(),
                    address:"",
                    logo:null,
                    isActive:true,
                    homeHeaders:{
                        main:`ברוכים הבאים ל- ${siteName.trim()}!`,
                        sub:`${details.trim()}`
                    },
                    details: details.trim(),
                    subject: subject.trim(),
                    theme,
                    categories:[],
                    jobs: [],
                    branches: [],
                    clients: [],
                    advertisments: [],
                    navbar:[{
                        btnName:"עמוד הבית",
                        link: "/home",
                        include: true,
                        },
                        {
                        btnName:"המוצרים שלנו",
                        link: "/products",
                        include: true,
                        },
                        {
                        btnName:"סניפים ושעות פעילות",
                        link: "/our_branches",
                        include: true,
                        },
                        {
                        btnName:"בואו לעבוד איתנו!",
                        link: "/our_jobs",
                        include: true,
                        },
                        {
                        btnName:"שירות לקוחות",
                        link: "/helpdesk",
                        include: true,
                        }
                    ],
                    social:{
                        instagram:{
                            include:false,
                            url:"",
                        },
                        facebook:{
                            include:false,
                            url:"",
                        },
                        whatsapp:{
                            include:false,
                            url:"",
                        }
                    },
                    hasHomeAdv:false,
                    homeAdvUrl:"",
                    about:[],
                    key_words: keyWordsArr,
                    createdAt: new Date(),
                };
                setWebsiteSettings(newSettings)
                setProgressState(3);
                window.scrollTo({
                    top: 0,
                    behavior:"smooth"
                })
                nav("/webingo/payment-form");
            } catch(err){
                console.error("Error creating website: ", err);
            }
        }
    }

    // ====================================
    // Settings form - handle main behavior
    // ====================================
    // Handle domain checking
    const checkDomain=async()=>{
        // Initiate error and suggestions at any new check
        setDomainCheckError('');
        setDomainSuggestions([]);
        // Input empty:
        if(!domainName.trim() || domainName.trim() === ""){
            setDomainCheckError('אנא הזן שם עבור הדומיין.');
            return;
        }
        // Input domain doesn't includes a dot
        if( !domainName.includes(".")){
            setDomainCheckError("הדומיין לא חוקי!")
            return;
        }
        // Input domain is not one of the available domains given
        if(
            domainName.split(".")[1] !== "com" && domainName.split(".")[1] !== "website" && domainName.split(".")[1] !== "site" && domainName.split(".")[1] !== "org" && domainName.split(".")[1] !== "net" && domainName.split(".")[1] !== "bizz" && domainName.split(".")[1] !== "info" && domainName.split(".")[1] !== "store" && domainName.split(".")[1] !== "shop" && domainName.split(".")[1] !== "online" && domainName.split(".")[1] !== "tech" && domainName.split(".")[1] !== "app")
            {
                // Display which options available for domain name requested
                const options = await getOptions(domainName, false);
                setDomainSuggestions(options.res);
                setDomainCheckError("סיומת דומיין לא תקינה!");
                return;
        }
        setIsDomainChecking(true);
        await new Promise(resolve => setTimeout(resolve , 800))
        try {
            // Check if website already exists
            const websiteRef = await getWebsite("settings.domain", domainName);
            // Check available options for domain requested
            const options = await getOptions(domainName, true);
            if(websiteRef !== null){
                // Domain check passed but website already exists
                if(options.message === "passed"){
                    setDomainCheckError(`הדומיין ${domainName} אינו זמין.`);
                    setDomainSuggestions(options.res);
                    return;
                }
                // Domain check error and website already exists
                if(options.message === "error"){
                    setDomainCheckError("חלה שגיאה בפעולה, נא לרענן את הדף ולנסות שוב");
                    return;
                }
            }
            else{
                // Website check passed and domain check passed => but domain is ours :)
                if(options.message === "takenByUs"){
                    setDomainCheckError("בחירה מעולה! אבל הדומיין הזה כבר תפוס :)");
                    return;
                }
                // Website check passed but domain check got error
                if(options.message === "error"){
                    setDomainCheckError("משהו השתבש, אנא נסה שוב מאוחר יותר");
                    return;
                }
                // Website check passed and domain check passed => domain selected successfuly
                setDomainCheckError("הדומיין נבחר בהצלחה!");
                return;
            }
        } catch (error) {
            console.error(error);
            setDomainCheckError('שגיאה בבדיקת זמינות הדומיין. נסה שוב');
        } finally{
            setIsDomainChecking(false);
        }
    }
    // Check for available domain options
    const getOptions = async (_domain, isValid)=>{
        
        // Define options available by webingo
        const options =  [".com",".website",".site",".org",".net",".app",".tech",".online",".store",".shop",".bizz",".info"];
        
        // At checkDomain function if given isValid as false => means that didn't passed check
        // And break the options check here before filter
        if(!isValid){return {message:"notValid", res:options};}
        
        // Catch the domain name selected
        const domain = _domain.split(".")[0];

        // Differ our domain from options available
        if(domain.toLowerCase() === "webingo" || _domain.toLowerCase() === "webingo.site"){
            return {message:"takenByUs", res:false};
        }

        try{

            const docsRef = await getCollectionDocs("websites");
            // Get all domains exists on firestore collection
            const userDomains = docsRef.map((doc)=>doc?.settings?.domain);
            
            // Create options according to domain requested
            const mapedOptions = options.map(ext => `${domain}${ext}`);
            
            // Filter options according to availability domains
            const availableOptions = mapedOptions.filter(fullDomain => !userDomains.includes(fullDomain));
            
            // Return the available options and a passed message
            return {message:"passed", res:availableOptions};
        } catch(err){
            console.error("Error on get domain options: ",err);
            return {message:"error",res:null};
        }
    }
    // Deploy the domain options available to suggest to client
    const deploySuggestions=()=>{
        try{
            return domainSuggestions.map((sug, inx)=>{
                return <li dir="ltr" key={`domain_sug_li_${inx}`}>{sug}</li>
            })
        }catch(err){
            console.error("deploay suggestions error: ",err);
        }
    }
    // Keywords adding handle
    const addKeyWord=()=>{
        try{
            setKeyWordsArr([...keyWordsArr, keyWord.trim()])
        } catch(err){
            console.error("error adding key word at SubscriptionContext.jsx: ",err);
        }
    }
    // Keywords deployment
    const deployKeyWords=()=>{
        try{
            return keyWordsArr.map((word, inx)=>{
                return <KeyWordCard key={`keyWordCard_num_${inx}`} word={word} arr={keyWordsArr} setArr={setKeyWordsArr}/>
            })
        } catch(err){
            console.error("error deploying key words at SubscriptionContext.jsx: ",err);
        }
    }
    // Theme change handle
    const changeScheme=(val)=>{
        try{
            const res =  themeOptions.filter((opt)=>{
                return opt.name === val;
            })
            setTheme(res[0].scheme_colors);
        } catch(err){
            console.error("Error changing scheme at SubscriptionContext.jsx: ", err);
        }
    }

    // ===============
    // Settings form => Example website => jobs page
    // ===============
    // Handle deploy requirements at jobs page
    const deployReqs =(item)=>{
        return item.requirements.map((req, inx)=>{
            return <li key={`exampleJobReq_${req}_${inx}`} className='exampleDescLine_li' >{req}</li>
        })
    }
    // Handle deploy benefits at jobs page
    const deployBenefs =(item)=>{
        return item.benefits.map((benefit, inx)=>{
            return <li key={`exampleJobReq_${benefit}_${inx}`} className='exampleDescLine_li' >{benefit}</li>
        })
    }
    // Handle deploy description at jobs page
    const deployDesc=(theme, item)=>{
        return <div className="exampleDesc_sub_div" dir='rtl'>
            <h2 className='exampleDescLine_h' style={{color:theme.accent_color}}>תיאור כללי</h2>
            <p className='exampleDescLine_p'>{item.details}</p>
            <h2 className='exampleDescLine_h' style={{color:theme.accent_color}}>דרישות המשרה</h2>
            <ul className='exampleDescLine_ul'>{deployReqs(item)}</ul>
            <h2 className='exampleDescLine_h' style={{color:theme.accent_color}}>יתרונות</h2>
            <ul className='exampleDescLine_ul'>{deployBenefs(item)}</ul>
        </div>
    }

    // =====================
    // Payment proccess form
    // =====================
    // Expiration date of payment card check
    const checkExpDate =(getTodayDate)=>{
        const today = getTodayDate();
        if(today> expiryDate){
            alert("תוקף כרטיס האשראי פג.\nאנא בחר/י כרטיס בתוקף!");
            return false;
        }
        return true;
    }
    // Payment proccess main function => basically check all inputs with correct regex
    // And using the checkExpDate function on the card expiration date
    const handlePayment = async(getTodayDate)=>{
        try{
            if(!cardName || !cardNumber || !expiryDate || !cvv || cardName==="" || cardNumber==="" || expiryDate==="" || cvv===""){
                setPaymentMessage("נא מלא את כל השדות תחילה!");
                return false;
            }
            const regexName = /^(?:[A-Za-z]{1,17} [A-Za-z]{1,17}|[א-ת׳']{1,17} [א-ת׳']{1,17}|[א-ת׳']{1,17})$/;
            const regexCVV = /^\d{3}$/;
            const regexNumber = /^\d{4}\s\d{4}\s\d{4}\s\d{4}$/;
            if(!cardName.match(regexName)){
                setPaymentMessage("שם בעל הכרטיס אינו תקין");
                return false;
            }
            if(!cardNumber.match(regexNumber)){
                setPaymentMessage("אנא בדוק את מספר האשראי שהזנת");
                return false;
            }
            if(!cvv.match(regexCVV)){
                setPaymentMessage("CVV חייב להיות בעל 3 ספרות בלבד.");
                return false;
            }
            if(!checkExpDate(getTodayDate)){
                setPaymentMessage("תוקף כרטיס האשראי אינו תקין! אנא וודא כי הזנת תאריך בתוקף.");
                return false;
            }
            return true;
        } catch(err){
            console.error(err);
        }
    }
    // Main function that create the website on firestore
    const handleCreateWebsite =async(nav, getTodayDate)=>{
        try{
            setPaymentFlag(true);
            await new Promise(resolve => setTimeout(resolve, 1000));
            // First check the inputs
            const pay = await handlePayment(getTodayDate);
            // Stop if anything wrong
            if(!pay)return;
            // Main struct of website document on firestore
            // Holds the owner data and settings data from previous forms
            // Also holds logs array to manage clients logs at website
            const newWebsite = {
                owner: ownerData,
                settings: websiteSettings,
                logs:[],
                createdAt: new Date(),
            }
            // Attempt to create the website at firestore
            const res = await handleSignUp(ownerCredentials?.email, ownerCredentials?.password, newWebsite);
            // Creation succeeded => delete the storage data had and move to sign in page
            if(res.message === "success"){
                window.scrollTo({
                    top: 0,
                    behavior:"smooth"
                })
                sessionStorage.removeItem("webingo_ownerData");
                sessionStorage.removeItem("webingo_ownerCredentials");
                sessionStorage.removeItem("webingo_websiteSettings");
                sessionStorage.removeItem("webingo_website");
                sessionStorage.removeItem("webingo_progress");
                // Condiser to navigate to a "thanks for subscribe" page after payment and
                // Send an email to client of "thanks for subscribe" that notify him that we
                // Wait for the payment to pass and he will get another email with the link
                // To sign in page => currently not in use
                nav("/webingo/signin");
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
            // If for any reason the first check at owner form didn't work to find that
            // The email is already exists/not valid and creation failed => notify user
            if(res.message === "emailTaken"){
                setPaymentMessage("האימייל כבר רשום במערכת, למעבר לעמוד התחברות לחץ - ");
            }
            if(res.message === "emailNotValid"){
                setPaymentMessage("קיימת בעיה עם האימייל שהוזן למשתמש, נסה לחזור לעמוד יצירת משתמש ולנסות שנית עם אימייל אחר");
            }
            if(res.message === "error"){
                setPaymentMessage("משהו השתבש, נסו לרענן את הדף או לבצע פעולה זו בשנית מאוחר יותר, עמכם הסליחה.");
            }
        } catch(err){
            console.error("couldn't create the website: ", err);
        } finally{
            setPaymentFlag(false);
        }
    }


    const val = {

        // Main:
        problem,
        progressState,
        setProgressState,

        // Owner form:
        ownerName,
        setOwnerName,
        ownerEmail,
        setOwnerEmail,
        password,
        setPassword,
        rePassword,
        setRePassword,
        ownerPhone,
        setOwnerPhone,
        handleCreateUser,

        // Settings form:
        domainName,
        setDomainName,
        siteName,
        setSiteName,
        email,
        setEmail,
        phone,
        setPhone,
        details,
        setDetails,
        subject,
        setSubject,
        theme,
        changeScheme,
        keyWord,
        setKeyWord,
        keyWordsArr,
        setKeyWordsArr,
        handleCreateSettings,
            // Dropdown deployment
        categoryOptions,
        themeOptions,
            // Domain process:
        isDomainChecking,
        domainCheckError,
        setDomainCheckError,
        domainSuggestions, 
        setDomainSuggestions,
        deploySuggestions,
        checkDomain,
            // ExampleWebsite
        deployDesc,
            // Keywords handle:
        deployKeyWords,
        addKeyWord,

        // Payment form:
        paymentMessage,
        setPaymentMessage,
        cardName,
        setCardName,
        cardNumber,
        setCardNumber,
        expiryDate,
        setExpiryDate,
        cvv,
        setCvv,
        paymentFlag,
        handleCreateWebsite,
    };
    return (
        <SubscriptionContext.Provider value={val}>
            {children}
        </SubscriptionContext.Provider>
    )
}